import { Field } from 'formik';
import {
  Select,
  FormControl,
  InputGroup,
  Input,
  InputRightElement,
  Button,
  Box, useStyleConfig,
} from '@chakra-ui/react';
import ElementInstructions from '../components/ElementInstructions';
import ElementHeading from '../components/ElementHeading';
import ElementErrorMessage from '../components/ElementErrorMessage';
import { formatOption } from '../../handlers/utils';
import { handleChange } from './utils';
import { handleNewSelect } from './utils';
import InputWrapper from '../components/InputWrapper';

const RSSelect = (
  {
    fieldName,
    qObj,
    props,
    index,
    isMultiple = false,
  },
) => {
  const formikProps = props.formikProps;
  const stateProps = props.stateProps;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const addAnotherId = 'addAnother_' + qObj.qid;
  if (typeof qObj.options !== 'undefined') {
    return (
      <Field name={fieldName}>
        {({ field, form }) => {
          return (
            <FormControl
              isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}
            >
              <ElementHeading qObj={qObj} props={props} />
              <ElementInstructions instructions={qObj.instructions} />

              <InputWrapper>
                <Select
                  {...field}
                  multiple={isMultiple}
                  onChange={e =>
                    handleChange(
                      stateProps,
                      formikProps,
                      index,
                      qObj,
                      e.currentTarget.value
                    )
                  }
                >
                  {qObj.options.map(option => {
                    return formatOption(option);
                  })}
                </Select>
              </InputWrapper>
              {qObj.hasalternate && (
                <Box sx={{ marginTop: '20px' }}>
                  Add Another:
                  <InputGroup>
                    <Input
                      id={addAnotherId}
                      onKeyPress={e => {
                        if (e.key === 'Enter')
                          handleNewSelect(stateProps, formikProps, qObj);
                      }}
                    />
                    <InputRightElement width="4.5rem">
                      <Button
                        sx={{...buttonStyles.primary}}
                        h="1.75rem"
                        size="sm"
                        onClick={e => {
                          handleNewSelect(stateProps, formikProps, qObj);
                        }}
                      >
                        Add
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </Box>
              )}
              <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
            </FormControl>
          );
        }}
      </Field>
    );
  } else {
    return null;
  }
};

export default RSSelect;
